import "./sliderItem.scss";
import * as utils from "shell/app/app.utils";
import classNames from "classnames";
import parse from "html-react-parser";

export type SliderItemData = {
  name: string;
  copy: string;
  image: string;
};

interface sliderItemProps extends SliderItemData {
  active: boolean;
  className: string;
  onClick: (i: number) => void;
  index: number;
  trans: number;
}

const SliderItem: React.FC<sliderItemProps> = (props) => {
  const handleClick = () => props.onClick(props.index);

  return (
    <div
      className={classNames("slider-item", props.className, {
        "is-active": props.active,
      })}
      onClick={handleClick}
      data-trans={props.trans}
    >
        <div className="slider-item-phone">
          <div className="slider-item-phone__copy"><p>{parse(props.copy)}</p></div>
          <img src={utils.assetPath(props.image)} alt="" />
        </div>
        <h4
          className={classNames("slider-item__name", {
            "is-mini": !props.active,
          })}
        >
          {props.name}
        </h4>
    </div>
  );
};

export default SliderItem;
